import React from 'react';

import { Helmet } from 'react-helmet-async';

const HomeSEO = () => (

<Helmet>

<title>Mealzy Foods - Fresh Food & Vegetable Delivery App | Order Online in Pune</title>

<meta name="description" content="Order fresh, delicious meals and farm-fresh vegetables delivered to your doorstep in Pune, Maharashtra. India's fastest growing food delivery app with 4.8★ rating, 10k+ customers & 500+ daily orders." />

<meta name="keywords" content="Mealzy Foods Pune, food delivery near me Pune, vegetable delivery near me Pune, Hinjawadi food delivery app, Pimpri Chinchwad meal delivery, Maharashtra fresh food delivery, fresh vegetable delivery app, cooked meals and vegetables delivery, South Indian food delivery Pune, farm fresh vegetables Pune, ready to eat meals delivery, healthy meal delivery service, Mealzy Foods app download, Mealzy Foods menu Pune, Mealzy Foods delivery time, order from Mealzy Foods, food and vegetable delivery in one app, 30 minute food delivery Pune, cash on delivery food app Pune, real time food tracking app, customizable meal orders Pune, hygienic food delivery service, dosa delivery Pune, idli vada delivery Hinjawadi, North Indian thali delivery, Maharashtra traditional food delivery, filter coffee delivery Pune, authentic South Indian breakfast delivery, organic food delivery, healthy food delivery, fresh food delivery, home food delivery, breakfast food delivery near me, ready made food delivery, order cooked meals and vegetables online Pune Maharashtra, food delivery Pune, vegetable delivery Maharashtra, online food order Hinjawadi, home delivery Pune, Indian food delivery, fresh meals, farm vegetables, Mealzy Foods, fast delivery" />

<meta name="robots" content="index, follow" />

<meta name="viewport" content="width=device-width, initial-scale=1.0" />

<meta name="author" content="Mealzy Foods" />

<link rel="canonical" href="https://mealzyfoods.in" />

</Helmet>

);

export default HomeSEO;
